import { cn } from '@pray/shared/utils/styles';

type ThinkingSectionProps = {
  messageId: string;
  thinking: string;
  isExpanded: boolean;
  onToggle: (messageId: string) => void;
  styles: Record<string, string>;
};

export function ThinkingSection({ messageId, thinking, isExpanded, onToggle, styles }: ThinkingSectionProps) {
  return (
    <div className={styles.thinkingSection}>
      <button
        type="button"
        className={styles.thinkingToggle}
        onClick={() => onToggle(messageId)}
        aria-expanded={isExpanded}
      >
        <span className={styles.thinkingIcon}>💭</span>
        <span>{isExpanded ? 'Hide reasoning' : 'Show reasoning'}</span>
        <span className={cn(styles.chevron, isExpanded && styles.expanded)}>▼</span>
      </button>
      {isExpanded && <div className={styles.thinkingContent}>{thinking}</div>}
    </div>
  );
}
